<div class="alert alert-info">
  <div [translate]="'newAppInfo'"></div>
  <a href="https://go.unityworks.app">https://go.unityworks.app</a>
</div>

<span id="login-auth0lock"></span>
